'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = organizations;
exports.add = add;
exports.areTopsLoaded = areTopsLoaded;
exports.isLoaded = isLoaded;
exports.isMenuProvided = isMenuProvided;
exports.isMenuRequired = isMenuRequired;
exports.load = load;
exports.loadTops = loadTops;
exports.setMenu = setMenu;
exports.setSelected = setSelected;

var _utils = require('helpers/utils');

var _config = require('config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = _config.app.entities.organizations;

var ADD = 'organizations/ADD';
var LOAD = 'organizations/LOAD';
var LOAD_FAIL = 'organizations/LOAD_FAIL';
var LOAD_SUCCESS = 'organizations/LOAD_SUCCESS';
var LOAD_TOPS = 'organizations/LOAD_TOPS';
var LOAD_TOPS_FAIL = 'organizations/LOAD_TOPS_FAIL';
var LOAD_TOPS_SUCCESS = 'organizations/LOAD_TOPS_SUCCESS';
var SET_SELECTED = 'organizations/SET_SELECTED';
var SET_MENU = 'organizations/SET_MENU';

var initialData = config.initialData || [];
var initialState = {
  config: config,
  loaded: false,
  loading: false,
  menu: [],
  organizations: initialData,
  selected: [],
  tops: {
    loaded: false,
    loading: false,
    items: []
  }
};

function organizations() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  function mergeOrganizations(toMerge) {
    var parsedData = toMerge.map(function (org) {
      return {
        id: org.id,
        label: org.name,
        group: 'organizations',
        references: org.references,
        tag: 'Présenté par'
      };
    });

    return (0, _utils.mergeCollections)(parsedData, state.organizations);
  }

  switch (action.type) {
    case ADD:
      return (0, _extends3.default)({}, state, {
        organizations: (0, _utils.findInCollectionOrAdd)(action.item, state.organization)
      });
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loaded: false,
        loading: true
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loaded: false,
        loading: false
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loaded: true,
        loading: false,
        organizations: action.result.data ? mergeOrganizations(action.result.data) : state.organizations
      });
    case LOAD_TOPS:
      var newLoadTops = {
        items: [],
        loaded: false,
        loading: true
      };
      return (0, _extends3.default)({}, state, {
        tops: newLoadTops
      });
    case LOAD_TOPS_FAIL:
      var newLoadTopsFail = {
        items: [],
        loaded: false,
        loading: false
      };
      return (0, _extends3.default)({}, state, {
        tops: newLoadTopsFail
      });
    case LOAD_TOPS_SUCCESS:
      var newLoadTopsSuccess = {
        items: action.result.data ? mergeOrganizations(action.result.data, state.tops.items) : state.tops.items,
        loaded: true,
        loading: false
      };
      return (0, _extends3.default)({}, state, {
        organizations: action.result.data ? mergeOrganizations(action.result.data, state.organizations) : state.organizations,
        loaded: true,
        loading: false,
        tops: newLoadTopsSuccess
      });
    case SET_MENU:
      var filteredCollection = (0, _utils.filterCollectionFromParams)(state.organizations, action.menu);

      return (0, _extends3.default)({}, state, {
        menu: config.menuOrder ? (0, _utils.orderByField)(filteredCollection, config.menuOrder) : filteredCollection
      });
    case SET_SELECTED:
      return (0, _extends3.default)({}, state, {
        selected: (0, _utils.filterCollectionFromParams)(state.organizations, action.selected)
      });
    default:
      return state;
  }
}

function add(organization) {
  return {
    type: ADD,
    item: organization
  };
}

function areTopsLoaded(globalState) {
  return globalState.organizations && globalState.organizations.tops && globalState.organizations.tops.loaded;
}

function isLoaded(globalState) {
  return globalState.organizations && globalState.organizations.loaded;
}

function isMenuProvided() {
  return Array.isArray(config.menu) && config.menu.length > 0;
}

function isMenuRequired() {
  return config.inFilters;
}

function load(ids) {
  if (!ids || Array.isArray(ids) && ids.length === 0) {
    return {
      type: LOAD_SUCCESS,
      result: { organizations: false }
    };
  }

  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/organizations?order=name&id=' + ids);
    }
  };
}

function loadTops() {
  return {
    types: [LOAD_TOPS, LOAD_TOPS_SUCCESS, LOAD_TOPS_FAIL],
    promise: function promise(client) {
      return client.get('/calendars/' + process.env.CALENDAR_ID + ('/organizations?order=references&direction=desc&per=' + (config.limit || 10)));
    }
  };
}

function setMenu(menu) {
  return {
    type: SET_MENU,
    menu: menu
  };
}

function setSelected(selected) {
  return {
    type: SET_SELECTED,
    selected: Array.isArray(selected) ? selected : (0, _utils.splitIdsList)(selected)
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/organizations.js
// module id = 134
// module chunks = 0